import { useTranslation } from 'react-i18next';

const Check = () => (
  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const StepIndicator = ({ steps = [], currentStep = 0, className = '' }) => {
  const { t } = useTranslation();
  if (!steps.length) return null;
  return (
    <ol
      className={`flex items-center w-full overflow-x-auto ${className}`}
      aria-label={t('ui.steps')}
    >
      {steps.map((step, idx) => {
        const isCompleted = idx < currentStep;
        const isCurrent = idx === currentStep;
        const isLast = idx === steps.length - 1;
        const circle = isCompleted
          ? 'bg-accent-600 border-accent-600 text-white'
          : isCurrent
            ? 'bg-primary-600 border-primary-600 text-white'
            : 'bg-white dark:bg-slate-800 border-slate-300 dark:border-slate-700 text-slate-400 dark:text-slate-400';
        const line = idx < currentStep ? 'bg-accent-600' : 'bg-slate-200 dark:bg-slate-700';
        const label = isCurrent
          ? 'text-primary-700 dark:text-primary-300 font-semibold'
          : isCompleted
            ? 'text-slate-700 dark:text-slate-300'
            : 'text-slate-400 dark:text-slate-400';
        return (
          <li key={idx} className={`flex items-center ${isLast ? '' : 'flex-1'} min-w-0`}>
            <div className="flex flex-col items-center min-w-0">
              <div
                className={`w-8 h-8 rounded-full border-2 flex items-center justify-center text-sm font-semibold flex-shrink-0 ${circle}`}
                aria-current={isCurrent ? 'step' : undefined}
              >
                {isCompleted ? <Check /> : idx + 1}
              </div>
              <span className={`mt-1 text-xs text-center whitespace-nowrap ${label}`}>
                {step.label}
              </span>
            </div>
            {!isLast && <div className={`flex-1 h-0.5 mx-2 ${line}`} />}
          </li>
        );
      })}
    </ol>
  );
};

export default StepIndicator;
